import { z } from "zod";

/** One turn of the onboarding first-invoice conversation. */
export const firstInvoiceMessageSchema = z.object({
  role: z.enum(["user", "assistant"]),
  content: z.string().trim().min(1, { message: "Message is empty" }).max(1000, { message: "Message is too long" }),
});

/**
 * Payload for the onboarding demo that creates the organization's first invoice.
 *
 * The whole conversation is sent on every turn — the assistant asks for whatever
 * is still missing, so the facts accumulate across messages rather than in a
 * single sentence. Callers should send the last 20 turns at most.
 */
export const createFirstInvoiceSchema = z.object({
  messages: z
    .array(firstInvoiceMessageSchema)
    .min(1, { message: "At least one message is required" })
    .max(20, { message: "Conversation is too long" }),
  language: z.string().optional(),
});

export type ZodFirstInvoiceMessageSchema = z.infer<typeof firstInvoiceMessageSchema>;
export type ZodCreateFirstInvoiceSchema = z.infer<typeof createFirstInvoiceSchema>;
